<template>
  <a-layout class="work-layout" >
    <work-menu />
    <a-layout-content>
      <router-view />
    </a-layout-content>
    <!-- <LinkTop/> -->
  </a-layout>
</template>

<script>
import WorkMenu from '@/components/WorkMenu'
// import LinkTop from '@/components/LinkTop'

export default {
  name: 'WorkLayout',
  components: {
    WorkMenu
    // LinkTop
  }
}
</script>

<style lang="less" scoped>
.ant-layout {
  background: #F6F8FB !important;
}
.work-layout {
  height: calc(100vh - 64px);
  background: #F6F8FB;
  display: flex;
  /deep/ .ant-layout-content {
    background: #fff !important;
    padding: 12px;
    margin: 12px;
    border-radius: 2px;
  }
}
</style>
